App.factory('zochaLifeInsuranceService', ['$q', 'baseService', 'Config', function($q, baseService, Config) {
    function ZochaLifeInsuranceService() {
        this.dataList = function(data) {
            return baseService.post(Config.API_URL + '/zocha/lifeInsuranceDeclaration/list', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.get = function(uuid) {
            return baseService.get(Config.API_URL + '/zocha/lifeInsuranceDeclaration/' + uuid).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.add = function(data) {
            return baseService.post(Config.API_URL + '/zocha/lifeInsuranceDeclaration/save', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.originalCopyEntered = function(id) {
            return baseService.get(Config.API_URL + '/zocha/lifeInsuranceDeclaration/' + id + '/originalCopyEntered').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.active = function(id) {
            return baseService.get(Config.API_URL + '/zocha/lifeInsuranceDeclaration/' + id + '/active').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.cancel = function(id) {
            return baseService.get(Config.API_URL + '/zocha/lifeInsuranceDeclaration/' + id + '/cancel').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.withdraw = function(criteria) {
            return baseService.post(Config.API_URL + '/zocha/lifeInsuranceDeclaration/' + criteria.id + '/withdraw', criteria.data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.notify = function(criteria) {
            return baseService.post(Config.API_URL + '/zocha/lifeInsuranceDeclaration/' + criteria.id + '/notify', criteria.data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.getDeclaration = function(uuid) {
            return baseService.download(Config.API_URL + '/zocha/lifeInsuranceDeclaration/' + uuid + '/declaration').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.getStatement = function(uuid) {
            return baseService.download(Config.API_URL + '/zocha/lifeInsuranceDeclaration/' + uuid + '/statement').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.enterOriginalCopyBarcode = function(id) {
            return baseService.get(Config.API_URL + '/zocha/lifeInsuranceDeclaration/enterOriginalCopyBarcode/' + id).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.dataTransferList = function(data) {
            return baseService.post(Config.API_URL + '/zocha/lifeInsuranceTransfer/list', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.sendTransfer = function(data) {
            return baseService.post(Config.API_URL + '/zocha/lifeInsuranceTransfer/sendTransfer', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.saveDeclarations = function saveDeclarations(declarations) {
            var json = angular.toJson(declarations);

            console.log('saveDeclarations', json);

            return baseService.post(Config.API_URL + '/zocha/lifeInsuranceDeclaration/save', json);
        };

        this.findByIdentifier = function findByIdentifier(pesel) {
            var json = angular.toJson({
                "identifier": pesel
            });

            return baseService.post(Config.API_URL + '/zocha/user/findByIdentifier', json);
        };

        this.hasDeclarationByTypeAndIdentifier = function findByIdentifier(type, identifier) {
            var json = angular.toJson({
                "identifier": identifier,
                "type": type
            });

            return baseService.post(Config.API_URL + '/zocha/lifeInsuranceDeclaration/givenIdentifierHasDeclarationOfLifeInsuranceType', json);
        };

        this.hasLifeInsuranceDeclarations = function(id) {
            return baseService.get(Config.API_URL + '/zocha/user/'+id+'/hasLifeInsuranceDeclarations').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };
    }
    return new ZochaLifeInsuranceService();
}]);